(() => {
  const chartLabel = 'View Size Chart';
  const chartSelector = '.ks-container-app-block .ks-chart-modal-link.sizing-chart-modal-link';

  function setChartLabel(trigger) {
    trigger.setAttribute('aria-label', chartLabel);
    if (String(trigger.textContent || '').replace(/\s+/g, ' ').trim() === chartLabel) return;

    const walker = document.createTreeWalker(trigger, NodeFilter.SHOW_TEXT);
    const labelNodes = [];
    let node = walker.nextNode();
    while (node) {
      if (node.nodeValue?.trim() && !node.parentElement?.closest('svg')) labelNodes.push(node);
      node = walker.nextNode();
    }
    if (!labelNodes.length) return;

    const leadingWhitespace = labelNodes[0].nodeValue.match(/^\s*/)?.[0] || '';
    labelNodes[0].nodeValue = leadingWhitespace + chartLabel;
    labelNodes.slice(1).forEach((labelNode) => { labelNode.nodeValue = ''; });
  }

  function normalizeChartLaunchers() {
    document.querySelectorAll(chartSelector).forEach(setChartLabel);
  }

  normalizeChartLaunchers();
  new MutationObserver(normalizeChartLaunchers).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
